import { createFileRoute } from '@tanstack/react-router';

import { AccountMigrateSuccess } from 'src/apps/account/app/pages/AccountMigrateSuccess';

export const Route = createFileRoute('/_auth/_layout/account/migrate/success')({
  component: () => <AccountMigrateSuccess />,
});
